<template>
  <LayoutDownload>
    <div class="out boost">
      <div class="out-wrapper">
        <slot name="header" />
        <Header />
        <slot name="body" />
        <div class="out-intro">
          <p>1.烟花红包需在腾讯新闻6.3.50以上版本才可观赏领取，请到手机应用市场下载最新版本哦</p>
          <p>2.如何定制烟花：</p>
          <p>- 进入腾讯新闻定制烟花，会自动为您包入一份现金红包</p>
          <p>- 生成烟花口令，发送给好友</p>
          <p>- 好友打开腾讯新闻，将在首页观赏到您为Ta定制的烟花并领取红包</p>
          <div class="out-intro-btn" @click="showStrategyModal">
            <p>效果预览 <span></span></p>
          </div>
        </div>
      </div>
    </div>
    <teleport to="#modal">
      <StrategyModal v-if="strategyModal" @close="hideStrategyModal" />
    </teleport>
  </LayoutDownload>
</template>

<script lang="ts">
import { defineComponent, ref } from 'vue'
import LayoutDownload from '@/layouts/LayoutDownload.vue'
import StrategyModal from '../StrategyModal.vue'
import Header from '../Header.vue'
export default defineComponent({
  name: 'OutBox',
  emits: ['open'],
  props: ['time'],
  components: {
    LayoutDownload,
    StrategyModal,
    Header
  },
  setup() {
    const strategyModal = ref(false)
    const { body } = document

    const showStrategyModal = () => {
      strategyModal.value = true
      body.classList.add('locked')
    }

    const hideStrategyModal = () => {
      strategyModal.value = false
      body.classList.remove('locked')
    }

    return {
      strategyModal,
      showStrategyModal,
      hideStrategyModal
    }
  }
})
</script>

<style lang="scss">
.layer {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 10;
  background-color: rgba(0, 0, 0, 0.75);
}
.out {
  position: relative;
  width: 375px;
  min-height: 100vh;
  padding-bottom: 40px;
  font-size: 12px;
  color: #fff;
  background-image: linear-gradient(to bottom, #000007, #010c44 50%, #170f62 150%);
}

.out-wrapper {
  width: 375px;
  height: 100%;
  background: url('../../assets/sky-bg.png') no-repeat center center;
  background-size: 100%;
}

.out-rule {
  position: absolute;
  top: 55px;
  right: 0;
}

.out-box {
  margin-top: 18px;
  text-align: center;

  &-title {
    display: flex;
    padding: 0 30px;
    justify-content: center;
    align-items: center;
  }

  &-text {
    text-align: center;
    font-size: 14px;
    font-weight: 500;
    line-height: 1.43;
    font-family: TTTGB;

    span {
      color: #fdde52;
    }
  }

  &-avatar {
    width: 16px;
    height: 16px;
    margin-right: 3px;
    flex-shrink: 0;
    position: relative;
    top: 2px;

    img {
      border-radius: 16px;
    }
  }

  &-icon {
    display: flex;
    justify-content: center;
    align-items: center;
    margin: 34px auto 30px;
    width: 189px;
    height: 168px;
    background: url(https://sola.gtimg.cn/aoi/sola/20201221234644_zMOF1fOjus.png) no-repeat center center;
    background-size: 100%;
    &-bg {
      position: relative;
      width: 76px;
      height: 76px;

      p {
        position: absolute;
        width: 100%;
        bottom: 8px;
        font-size: 12px;
        text-align: center;
      }
    }
  }

  &-bless {
    margin-top: 6px;
    font-family: TTTGB;
    font-size: 20px;
    color: #ff7d3d;
  }

  &-img {
    margin: 30px auto 0;
    width: 202px;
    height: 270px;
    background: url(https://sola.gtimg.cn/aoi/sola/20201221231309_MUG6rtVAiO.png) no-repeat center center;
    background-size: 100%;
  }

  &-url {
    margin: 0 auto;
    width: 32px;
    height: 32px;
    border-radius: 16px;
    overflow: hidden;
  }

  &-nick {
    font-size: 14px;
    font-weight: 500;
    line-height: 1.25;
    font-family: TTTGB;
    color: #fdde52;
    margin: 4px auto 7px;
  }

  &-tips {
    position: relative;
    font-family: TTTGB;
    font-size: 16px;
    line-height: 1.5;
    font-weight: 500;

    &:after,
    &:before {
      content: '';
      position: absolute;
      top: 50%;
      transform: translateY(-50%) scale(0.5);
      width: 70px;
      height: 1px;
      background: #fff;
    }
    &:before {
      left: 0;
    }
    &:after {
      right: 0;
    }
  }
}

.out-footer {
  display: flex;
  flex-direction: column;
  justify-content: center;
  width: 100%;
  &-btn {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    width: 295px;
    height: 46px;
    margin: 0 auto;
    border-radius: 23px;
    font-size: 16px;
    color: #fff;
    background-color: rgba(255, 255, 255, 0.1);

    &.active {
      background-image: linear-gradient(to left, #cf2c38, #fa434f 0%);
    }

    & + & {
      margin-top: 20px;
    }

    p + p {
      font-size: 11px;
      line-height: 1.09;
    }
  }
}

.out-intro {
  margin-top: 30px;
  padding: 0 30px;
  line-height: 1.33;
  font-size: 12px;

  p + p {
    margin-top: 10px;
  }

  &-btn {
    margin-top: 15px;
    font-family: TTTGB;
    font-size: 12px;
    font-weight: 500;
    color: #fee58c;

    span {
      display: inline-block;
      vertical-align: middle;
      margin-left: 3px;
      width: 10px;
      height: 9px;
      background: url('../../assets/icon-rule-more.png') no-repeat center center;
      background-size: 100%;
    }
  }
}

.modal-body {
  text-align: center;
  height: 400px;
  overflow: auto;
}

.appInfo {
  background: rgba(1, 8, 47, 1) !important;
  color: #fff !important;

  .btn {
    display: none;
    background-image: rgba(1, 8, 47, 1) !important;
  }
}
</style>
